import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../../appTheme"

export const optionListStyle = StyleSheet.create({

    parentContainer:
        { flex: 1, backgroundColor: appColors.lightBackgroundColor },
    childContainer:
    {
        flex: 1
    },
    loaderContainer:
        { flex: 1, justifyContent: 'center', alignItems: 'center' },
    buttonContainer:
        { flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 5 },
    sortContainer:
        { flexDirection: 'row', alignItems: 'center', paddingHorizontal: 10, backgroundColor: appColors.lightBackgroundColor, marginHorizontal: 10, borderRadius: 10, borderWidth: 1, borderColor: appColors.lightGrey },
    filterContainer:
        { flexDirection: 'row', alignItems: 'center', paddingHorizontal: 10, backgroundColor: appColors.lightBackgroundColor, borderRadius: 10, borderWidth: 1, borderColor: appColors.lightGrey },
    btnText:
        { fontFamily: appFonts.bold, fontSize: fontSize.smallFontSize, textTransform: 'capitalize' },
    btnCon:
        { backgroundColor: appColors.primary, padding: 1, borderRadius: 10 },
    badgeTxt:
        { fontFamily: appFonts.bold, fontSize: fontSize.badgeFontSize },
    badgeCon:
        { position: 'absolute', top: -4, right: -4, },
    listParent:
        { paddingHorizontal: 10, backgroundColor: appColors.light, marginVertical: 10, paddingVertical: 10, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderRadius: 10, marginHorizontal: 15 },
    listChild:
        { flexDirection: 'row' },
    badgeTexT:
    {
        color: appColors.lightDark, fontFamily: appFonts.bold, fontSize: fontSize.badgeFontSize, paddingHorizontal: 8, textAlign: 'center'
    },
    badgeCon2:
    {
        justifyContent: 'center', marginLeft: 7
    },
    iconCon:
        { paddingHorizontal: 10, paddingVertical: 10, backgroundColor: appColors.lightBackgroundColor, marginHorizontal: 10, borderRadius: 5, },
    iconCon2:
        { paddingHorizontal: 10, paddingVertical: 10, backgroundColor: appColors.lightBackgroundColor, borderRadius: 5, },
    searchCon:
        { flexDirection: 'row', alignItems: 'center', marginTop: 10 }


})
